export const authenticationErrors = (errorMessage) => {
    return 'Nieprawdiłowa nazwa użytkownika lub hasło.';
}